import React, {useCallback, useEffect, useMemo, useState} from "react";
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    DropdownMenu,
    DropdownToggle,
    FormGroup,
    Label,
    Row,
    UncontrolledDropdown,
} from "reactstrap";
import EmployeeCallType from "../../Components/Common/EmployeeCallType";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import EmployeeSelect from "../../Components/Common/EmployeeSelect";
import TeamSelect from "../../Components/Common/TeamSelect";
import {DatePicker} from "../../Components/Common/Flatpicker";
import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import {Autoplay, Mousewheel} from "swiper";
import {CalllogAnalysis, LineColumnArea} from "../Charts/ChartsJs/ChartsJs";
import {APIClient} from "../../helpers/api_helper";
import {
    POST_CALL_ANALYSIS_GRAPH_API,
    POST_CALL_ANALYSIS_MOM_TRENDS_API,
    POST_EMPLOYEE_CALLS_ANALYSIS_GRAPH_API,
} from "../../helpers/url_helper";
import {getPreviousCallAnalysisDate, setCurrentDate} from "../../Components/Common/DefaultDateSet";
import {formatFlatMonthPicker, formatFlatPickerDates, getBackgroundColor} from "../../Components/Common/ToCamelCase";
import Loader from "../../Components/Common/Loader";
import comingsoon from "../../assets/images/call-aten-rate.png";
import callanswerrate from "../../assets/images/call-atent-rate.png";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
const api = new APIClient();

const CallSummaryAnalysis = () => {
    // default date
    const previewsDate = getPreviousCallAnalysisDate();
    const currentDate = setCurrentDate();

    const [totalCallsData, setTotalCallsData] = useState([]);
    const [graphData, setGraphData] = useState([]);
    const [empwiseGraphData, setEmpWiseGraphdata] = useState([]);
    const [error, setError] = useState("");

    const [teamIndu, setTeamIndu] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    // callType state
    const [selectedOptions, setSelectedOptions] = useState([]);

    // date picker state
    const [selectedFromDate, setSelectedFromDate] = useState(previewsDate);
    const [selectedToDate, setSelectedToDate] = useState(currentDate);

    // employee wise state
    const [selectedEmployeeOptions, setSelectedEmployeeOptions] = useState([]);
    const [selectedEmployeeOptions2, setSelectedEmployeeOptions2] = useState([]);
    const [EmployeeDefaultWithoutTeam, setEmployeeDefaultWithoutTeam] = useState([]);
    const [prevEmployeesIds_Test, setPrevEmployeesIds_Test] = useState([]);

    const [isFirstEffectRun, setIsFirstEffectRun] = useState(false);
    const [EmployeeData, setEmployeeData] = useState([]);
    // Memoized formatted dates
    const formattedDates = useMemo(
        () => formatFlatMonthPicker(selectedFromDate, selectedToDate),
        [selectedFromDate, selectedToDate]
    );

    // Memoized date object using formattedDates
    const dateObj = useMemo(
        () => ({
            startDate: formattedDates.formattedStartDate,
            endDate: formattedDates.formattedEndDate,
        }),
        [formattedDates]
    );



    useEffect(() => {
        if (teamIndu) {
            if (!isFirstEffectRun && selectedEmployeeOptions?.length > 0) {
                let updatedIds =
                    prevEmployeesIds_Test.length > 0
                        ? prevEmployeesIds_Test
                        : selectedEmployeeOptions2?.map((option) => option?.id) || [];
                if (updatedIds.length > 0) {
                    fetchCallAnalysisList(updatedIds, [], dateObj);
                }
                setIsFirstEffectRun(true);
                setPrevEmployeesIds_Test(updatedIds);
            }
        } else {
            let updatedIds =
                prevEmployeesIds_Test.length > 0
                    ? prevEmployeesIds_Test
                    : EmployeeDefaultWithoutTeam?.map((option) => option?.id) || [];
            if (updatedIds.length > 0) {
                fetchCallAnalysisList(updatedIds, [], dateObj);
            }
            setIsFirstEffectRun(true);
            setPrevEmployeesIds_Test(updatedIds);
        }
    }, [selectedEmployeeOptions]);

    // Form Date function
    const handleFromDateChange = (dates) => {
        setSelectedFromDate(dates[0]);
    };

    // To Date function
    const handleToDateChange = (dates) => {
        setSelectedToDate(dates[0]);
    };

    // Lead List Table data Submit data
    const handleSubmit = async () => {
        let callType = selectedOptions?.map((option) => option?.value) || [];
        let updatedIds = selectedEmployeeOptions.map((userid) => userid?.id);
        let dateObj = {
            startDate: formattedDates.formattedStartDate,
            endDate: formattedDates.formattedEndDate,
        };

        fetchCallAnalysisList(updatedIds, callType, dateObj);
        setSelectedEmployeeOptions2(selectedEmployeeOptions);
        setError("");
    };

    // api credentials pass in function
    const getRequestData = useCallback(
        (updatedIds = [], callType = [], dateObj = {}) => {
            return {
                employeeIds: updatedIds || selectedEmployeeOptions2.map((userid) => userid?.id),
                callType: callType,
                startDate: dateObj.startDate,
                endDate: dateObj.endDate,
            };
        },
        [formattedDates, selectedEmployeeOptions2]
    );

    const fetchCallAnalysisList = useCallback(
        async (updatedIds = [], callType = [], dateObj = {}) => {
            setIsLoading(true);
            try {
                const requestData = getRequestData(updatedIds, callType, dateObj);
                const [momchangeData, graphResponse, empwiseGraphResponse] = await Promise.all([
                    api.create(`${POST_CALL_ANALYSIS_MOM_TRENDS_API}`, requestData),
                    api.create(`${POST_CALL_ANALYSIS_GRAPH_API}`, requestData),
                    api.create(`${POST_EMPLOYEE_CALLS_ANALYSIS_GRAPH_API}`, requestData),
                ]);

                if (momchangeData && momchangeData.success) {
                    setTotalCallsData(momchangeData.data);
                }

                if (graphResponse && graphResponse?.success) {
                    setGraphData(graphResponse.data);
                }
                if (empwiseGraphResponse && empwiseGraphResponse?.success) {
                    setEmpWiseGraphdata(empwiseGraphResponse.data);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setIsLoading(false);
            }
        },
        [getRequestData]
    );

    const totalHighestCallData = useMemo(() => {
        return [
            {
                id: 1,
                type: "CALL",
                analysisimg: totalCallsData?.highestTotalCall?.employeeWithHighestTotalCalls?.profileImageUrl, // Use imported image
                label: "Highest Total Call",
                highestcallName: totalCallsData?.highestTotalCall?.employeeWithHighestTotalCalls?.employeeName,
                totalCall: totalCallsData?.highestTotalCall?.employeeWithHighestTotalCalls?.totalCalls,
            },
            // {
            //     id: 2,
            //     analysisimg: totalCallsData?.highestTotalCall?.highestOutgoingCall?.profileImageUrl,
            //     label: "HIGHEST OUTGOING CALL",
            //     highestcallName: totalCallsData?.highestTotalCall?.highestOutgoingCall?.employeeName,
            //     totalCall: totalCallsData?.highestTotalCall?.highestOutgoingCall?.totalCalls,
            // },
            {
                id: 2,
                type: "CALL",
                analysisimg: totalCallsData?.highestTotalCall?.highestMissedCall?.profileImageUrl,
                label: "Highest Missed Call",
                highestcallName: totalCallsData?.highestTotalCall?.highestMissedCall?.employeeName,
                totalCall: totalCallsData?.highestTotalCall?.highestMissedCall?.totalCalls,
            },
            {
                id: 3,
                type: "CALL",
                analysisimg: comingsoon,
                label: "Missed Calls Rate",
                highestcallName: "",
                totalCall: (
                    <h5 className="text-success">
                        {totalCallsData?.highestTotalCall?.organizationMetrics?.averageMissedCallsRate}%
                        <span className="sn-call-summary-mom-txt">(MOM)</span>
                    </h5>
                ),
            },

            {
                id: 4,
                type: "CALL",
                analysisimg: callanswerrate,
                label: "Call Answer Rate",
                highestcallName: "",
                totalCall: (
                    <h5 className="text-success">
                        {totalCallsData?.highestTotalCall?.organizationMetrics?.averageMissedCallsRate}%
                        <span className="sn-call-summary-mom-txt">(MOM)</span>
                    </h5>
                ),
            },

            // {
            //     id: 5,
            //     analysisimg: totalCallsData?.highestTotalCall?.highestRejectedCall?.profileImageUrl,
            //     label: "HIGHEST REJECT CALL",
            //     highestcallName: totalCallsData?.highestTotalCall?.highestRejectedCall?.employeeName,
            //     totalCall: totalCallsData?.highestTotalCall?.highestRejectedCall?.totalCalls,
            // },
        ];
    }, [totalCallsData]);

    // total call and Mom change
    const totalCallData = useMemo(() => {
        return [
            {
                id: 1,
                usericon: "mdi mdi-phone-incoming",
                label: "Total Calls",
                totalCalls: totalCallsData?.totalmomCall?.allTotalCall || 0,
                totalCallMoM: totalCallsData?.totalmomCall?.momChanges?.[0]?.totalCallMoM || 0,
                changeClass:
                    parseFloat(totalCallsData?.totalmomCall?.momChanges?.[0]?.totalCallMoM) >= 0 ? "success" : "danger",
                coinName: "MoM",
                chartsColor: "#eca8f7",
            },
            {
                id: 2,
                usericon: "mdi mdi-phone-incoming",
                label: "Incoming Calls",
                totalCalls:
                    totalCallsData?.totalmomCall?.totalCall?.find((call) => call._id === "INCOMING")?.totalCalls || 0,
                totalCallMoM: totalCallsData?.totalmomCall?.momChanges?.[0]?.incomingCallMoM || 0,
                changeClass:
                    parseFloat(totalCallsData?.totalmomCall?.momChanges?.[0]?.incomingCallMoM) >= 0
                        ? "success"
                        : "danger",
                coinName: "MoM",
                chartsColor: "#eca8f7",
            },
            {
                id: 3,
                usericon: "mdi mdi-phone-outgoing",
                label: "Outgoing Calls",
                totalCalls:
                    totalCallsData?.totalmomCall?.totalCall?.find((call) => call._id === "OUTGOING")?.totalCalls || 0,
                totalCallMoM: totalCallsData?.totalmomCall?.momChanges?.[0]?.outgoingCallMoM || 0,
                changeClass:
                    parseFloat(totalCallsData?.totalmomCall?.momChanges?.[0]?.outgoingCallMoM) >= 0
                        ? "success"
                        : "danger",
                coinName: "MoM",
                chartsColor: "#eca8f7",
            },
            {
                id: 4,
                usericon: "mdi mdi-phone-missed",
                label: "Missed Calls",
                totalCalls:
                    totalCallsData?.totalmomCall?.totalCall?.find((call) => call._id === "MISSED")?.totalCalls || 0,
                totalCallMoM: totalCallsData?.totalmomCall?.momChanges?.[0]?.missedCallMoM || 0,
                changeClass:
                    parseFloat(totalCallsData?.totalmomCall?.momChanges?.[0]?.missedCallMoM) >= 0
                        ? "success"
                        : "danger",
                coinName: "MoM",
                chartsColor: "#eca8f7",
            },
            {
                id: 5,
                usericon: "mdi mdi-phone-remove",
                label: "Rejected Calls",
                totalCalls:
                    totalCallsData?.totalmomCall?.totalCall?.find((call) => call._id === "REJECTED")?.totalCalls || 0,
                totalCallMoM: totalCallsData?.totalmomCall?.momChanges?.[0]?.rejectedCallMoM || 0,
                changeClass:
                    parseFloat(totalCallsData?.totalmomCall?.momChanges?.[0]?.rejectedCallMoM) >= 0
                        ? "success"
                        : "danger",
                coinName: "MoM",
                chartsColor: "#eca8f7",
            },
        ];
    }, [totalCallsData]);

    //reset button
    const resetInputHistory = () => {};

    return (
        <React.Fragment>
            <div className="page-content sn-call-report-page-top">
                <Container fluid>
                    <BreadCrumb title="Summary" pageTitle="Summary" />
                    <Card className="h-100">
                        <CardBody>
                            <Row className="sn-header-select-employess-home sn-team-managment-tble sn-top-inputs-heading">
                                <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xs-12">
                                    <div className="sn-call-summary-date-picker">
                                        <DatePicker
                                            labelContent="From Date"
                                            getDate={selectedFromDate}
                                            options={{
                                                plugins: [
                                                  new monthSelectPlugin({
                                                    shorthand: true,
                                                    dateFormat: "F, Y",
                                                    theme: "light",
                                                  }),
                                                ],
                                                maxDate: new Date(),
                                              }}
                                            onChange={handleFromDateChange}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xs-12">
                                    <div className="sn-call-summary-date-picker">
                                        <DatePicker
                                            labelContent="To Date"
                                            getDate={selectedToDate}
                                            options={{
                                                plugins: [
                                                  new monthSelectPlugin({
                                                    shorthand: true,
                                                    dateFormat: "F, Y",
                                                    theme: "light",
                                                  }),
                                                ],
                                                maxDate: new Date(),
                                              }}
                                            onChange={handleToDateChange}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xs-12">
                                    <TeamSelect
                                        setSelectedEmployeeOptions={setSelectedEmployeeOptions}
                                        teamIndu={teamIndu}
                                        setTeamIndu={setTeamIndu}
                                        labelContent="Select Team"
                                    />
                                </div>

                                <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xs-12">
                                    <EmployeeSelect
                                        setEmployeeDefaultWithoutTeam={setEmployeeDefaultWithoutTeam}
                                        EmployeeDefaultWithoutTeam={EmployeeDefaultWithoutTeam}
                                        error={error}
                                        setError={setError}
                                        EmployeeDefault={
                                            teamIndu.length === 0 ? EmployeeDefaultWithoutTeam : EmployeeData
                                        }
                                        setEmployeeDefault={setEmployeeData}
                                        teamIndu={teamIndu}
                                        selectedEmployeeOptions={selectedEmployeeOptions}
                                        setSelectedEmployeeOptions={setSelectedEmployeeOptions}
                                        setSelectedEmployeeOptions2={setSelectedEmployeeOptions2}
                                        labelContent="Select Employee"
                                    />
                                </div>

                                <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 sn-header-select-employess-home">
                                    <FormGroup>
                                        <EmployeeCallType
                                            labelContent="Select Call Type"
                                            selectedOptions={selectedOptions}
                                            setSelectedOptions={setSelectedOptions}
                                        />
                                    </FormGroup>
                                </div>

                                <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xs-12">
                                    <FormGroup>
                                        <Label for="exampleSelect"></Label>
                                        <div id="exampleSelect" className="sn-call-apply-btn-reset mt-2">
                                            <Button
                                                id="exampleSelect"
                                                type="submit"
                                                color="danger"
                                                className=""
                                                onClick={handleSubmit}
                                                disabled={isLoading}
                                            >
                                                Apply
                                            </Button>
                                            <Button
                                                className=""
                                                style={{marginLeft: "10px"}}
                                                id="exampleSelect"
                                                outline
                                                color="danger"
                                                onClick={resetInputHistory}
                                                disabled={isLoading}
                                            >
                                                Reset
                                            </Button>
                                        </div>
                                    </FormGroup>
                                </div>
                            </Row>

                            {isLoading && (
                                <div className="loader-overlay">
                                    <Loader />
                                </div>
                            )}
                            <div className={`content ${isLoading ? "blurred" : ""}`}>
                                <Row>
                                    <Col lg={12} className="mt-4">
                                        <Swiper
                                            slidesPerView={1}
                                            spaceBetween={24}
                                            mousewheel={true}
                                            autoplay={{
                                                delay: 2000,
                                                disableOnInteraction: false,
                                            }}
                                            breakpoints={{
                                                640: {
                                                    slidesPerView: 2,
                                                },
                                                1024: {
                                                    slidesPerView: 2,
                                                },
                                                1200: {
                                                    slidesPerView: 3,
                                                },
                                                1600: {
                                                    slidesPerView: 5,
                                                },
                                            }}
                                            modules={[Autoplay, Mousewheel]}
                                            className="cryptoSlider sncall-analysis-slider-dashboard "
                                        >
                                            {(totalCallData || []).map((item, key) => (
                                                <SwiperSlide key={key} className={`item-voice item-voice-${item.id}`}>
                                                    <Card
                                                        className="sn-call-summary-heading-call-txt"
                                                        style={{border: "1px solid #cccccc2e"}}
                                                    >
                                                        <CardBody>
                                                            <div className="float-end ">
                                                                <UncontrolledDropdown>
                                                                    <div className="bg-light rounded-circle p-1 sn-call-summary-analysis-profile">
                                                                        <i className={item.usericon}></i>
                                                                    </div>
                                                                </UncontrolledDropdown>
                                                            </div>
                                                            <div className="d-flex align-items-center">
                                                                <h6 className="mb-0 fs-14">{item.label}</h6>
                                                            </div>
                                                            <Row className="align-items-end g-0">
                                                                <Col xs={12}>
                                                                    <h5 className="mb-2 mt-2">{item.totalCalls}</h5>
                                                                    <p
                                                                        className={`fs-13 fw-medium mb-0 text-${item.changeClass}`}
                                                                    >
                                                                        {item.totalCallMoM}%
                                                                        <span className="text-muted ms-2 fs-13 text-uppercase">
                                                                            ({item.coinName})
                                                                        </span>
                                                                    </p>
                                                                </Col>
                                                                {/* <Col xs={6}>
                                                                    <div
                                                                        className="apex-charts crypto-widget"
                                                                        dir="ltr"
                                                                    ></div>
                                                                </Col> */}
                                                            </Row>
                                                        </CardBody>
                                                    </Card>
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                    </Col>
                                </Row>

                                <Col className="col-xxl-12 order-xxl-0 order-first mt-4">
                                    <Row className="mt-4">
                                        <React.Fragment>
                                            {(totalHighestCallData || [])?.map((item, key) => (
                                                <Col lg={3} md={6} key={key}>
                                                    <Card className="sn-call-anlysis-card">
                                                        <CardBody>
                                                            <div className="d-flex flex-column align-items-center text-center">
                                                                {item.type === "CALL" && (
                                                                    <div className="avatar-sm">
                                                                        <span className="rounded-circle sn-call-analysis-profile-slide">
                                                                            {item?.analysisimg ? (
                                                                                <img
                                                                                    src={item?.analysisimg}
                                                                                    alt="Profile"
                                                                                    style={{
                                                                                        width: "40px", // Increased size for better visibility
                                                                                        height: "40px",
                                                                                        objectFit: "cover",
                                                                                        borderRadius: "50%",
                                                                                        marginBottom: "10px", // Space between image and text
                                                                                    }}
                                                                                />
                                                                            ) : (
                                                                                <div
                                                                                    className="rounded-circle d-flex justify-content-center align-items-center"
                                                                                    style={{
                                                                                        width: "40px",
                                                                                        height: "40px",
                                                                                        background: getBackgroundColor(
                                                                                            item.highestcallName
                                                                                        ),
                                                                                        fontWeight: "bold",
                                                                                        color: "#fff",
                                                                                        marginBottom: "10px", // Space between placeholder and text
                                                                                    }}
                                                                                >
                                                                                    {item.highestcallName
                                                                                        ? item.highestcallName
                                                                                          .charAt(0)
                                                                                          .toUpperCase()
                                                                                        : "?"}
                                                                                </div>
                                                                            )}
                                                                        </span>
                                                                    </div>
                                                                )}

                                                                {/* Text Section */}
                                                                <div className="w-100">
                                                                    <h6
                                                                        className="mb-0 mt-2 fs-14"
                                                                        style={{textTransform: "capitalize"}}
                                                                    >
                                                                        {item.label}
                                                                    </h6>
                                                                    <p className="text-uppercase fw-bold fs-13 text-muted mb-1">
                                                                        {item?.highestcallName}
                                                                    </p>
                                                                    <h5 className="mb-1 mt-1">{item.totalCall}</h5>
                                                                </div>
                                                            </div>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            ))}
                                        </React.Fragment>
                                    </Row>
                                </Col>

                                <Row className="mt-4">
                                    <Col lg={12}>
                                        <Card className="card-height-100 mt-4">
                                            <CardHeader className="align-items-center d-flex">
                                                <h4 className="card-title mb-0 flex-grow-1">Balance Overview</h4>
                                            </CardHeader>
                                            <div className="mt-4">
                                                <div id="chart">
                                                    <CalllogAnalysis graphData={graphData} />
                                                </div>
                                            </div>
                                        </Card>
                                    </Col>
                                </Row>

                                <Row className="mt-4">
                                    <Col className="mt-4" lg={12}>
                                        <Card>
                                            <CardHeader>
                                                <h4 className="card-title mb-0">Line & Column Chart</h4>
                                            </CardHeader>
                                            <CardBody>
                                                <LineColumnArea
                                                    employeeData={empwiseGraphData}
                                                    dataColors='["#f17171", "--vz-success"]'
                                                />
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </div>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default CallSummaryAnalysis;
